import serviceBase from "./serviceBase";
import { EndPoint } from "../appConfig";

var ScheduleService = Object.create(new serviceBase(EndPoint.Schedule));

/**
 * 登録されている、会議室を取得します。
 */
ScheduleService.getSchedule = function(users, start, end) {
    return this.post({
        targets: users,
        startTime: start.toISOString(),
        endTime: end.toISOString()
      });
};

export default ScheduleService;
